<template>
    <div class="h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">
                Mosquito Data Entry
                <b-badge>{{collectionCode}}</b-badge>
            </h2>
            <p class="tw-italic tw-text-gray-700">
                Select a collection code and add Mosquito data
            </p>
        </b-container>

        <b-modal id="ento-summary" centered ok-only :hide-header="true" size="lg" title="Ento Summary">
            <EntoDataSummary :collection-code="collectionCode" v-if="collectionCode" />
        </b-modal>

        <b-container fluid>
            <b-row>
                <b-col>
                    <b-form-input
                        label="Collection Code"
                        placeholder="Collection Code"
                        v-model="keyword"
                        size="lg"
                        @keypress.enter="search()"
                        @click:append="search()"
                    ></b-form-input>
                </b-col>
                <b-col cols="auto">
                    <b-button @click="search()" block size="lg" variant="success">
                       Search Code
                    </b-button>
                </b-col>
            </b-row>
        </b-container>

        <hr />

        <b-container fluid v-if="inMyGroups(['Ento Lead'])">
            <b-row>
                <b-col></b-col>
                <b-col cols="auto">
                    <b-button
                        @click="download(collectionCode)"
                        variant="success"
                        class="px-5"
                        size="lg"
                        :disabled="collectionCode == ''"
                    >
                        Download Collection Data
                    </b-button>
                </b-col>
                <b-col cols="auto">
                    <b-button
                        @click="download()"
                        variant="success"
                        class="px-5"
                        size="lg"
                    >
                        Download All Data
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
        <hr />

        <b-container fluid>

            <b-row>
                <b-col class="text-right">
                    <b-button
                        variant="success"
                        v-if="selectedCollectionCode && selectedCollectionCode.status == 'editing'"
                        @click="updateCollectionCodeStatus('locked')"
                        class="mx-2"
                    >
                        Lock Table
                    </b-button>
                    <b-button
                        variant="danger"
                        v-if="selectedCollectionCode && selectedCollectionCode.status == 'locked' && inMyGroups(['Ento Lead'])"
                        @click="updateCollectionCodeStatus('editing')"
                        class="mx-2"
                    >
                       Unlock Table
                    </b-button>
                </b-col>
            </b-row>

            <b-row v-if="(selectedCollectionCode && selectedCollectionCode.id) || (startDate && endDate)">
                <b-col class="tw-p-1">
                    <b-tabs
                        v-model="tabIndex"
                        content-class="mt-4"
                        justified
                        lazy
                    >
                        <b-tab title="Individual Mosquito Entry" active>
                            <template v-slot:title>
                                <h4>Individual Mosquito Entry</h4>
                            </template>

                            <EntoDataHOT
                                :collectionCode="collectionCode"
                                :collectionCodeStatus="collectionCodeStatus"
                                :start-date="startDate"
                                :end-date="endDate"
                                templateId="individual_mosquito_entry"
                            />
                        </b-tab>
                        <b-tab title="Delete">
                            <template v-slot:title>
                                <h4>Delete</h4>
                            </template>

                            <EntoDataHOT
                                :collectionCode="collectionCode"
                                :collectionCodeStatus="collectionCodeStatus"
                                :start-date="startDate"
                                :end-date="endDate"
                                templateId="deleted"
                            />
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
// import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import EntoDataHOT from "@/components/unitaid/ento-data/srilanka/EntoDataHOT.vue";

import EntoDataSummary from "@/components/unitaid/ento-data/EntoDataSummary";

import { mapActions } from "vuex";
import { mapState, mapGetters } from "vuex";
// import * as _ from "lodash";

export default {
    components: {
        EntoDataHOT,
        EntoDataSummary
    },
    mixins: [DashboardBaseTemplate],
    data: function () {
        return {
            keyword: "",
            collectionCode: "",
            collectionCodeStatus: "draft",
            collectionCodes: [],
            selectedCollectionCode: null,
            tabIndex: 0,
            formData: {},
            startDate: '',
            endDate: ''
        };
    },
    computed: {
        ...mapState('user', ['user', 'myGroups']),
        ...mapGetters('user', ['inMyGroups'])
    },
    created(){
        this.unpackUrlQueryParams(this.$route.query);
    },
    mounted() {
        if(this.$route.query.tabIndex) {
            this.tabIndex = parseInt(this.$route.query.tabIndex);
        }
    },
    methods: {
        ...mapActions("websheet", ["getEntoCollectionCodes", "getEntoData"]),
        search: async function () {
            const that = this;

            that.startDate = '';
            that.endDate = '';
            that.selectedCollectionCode = null;
            that.collectionCode = '';
            that.collectionCodeStatus = '';

            if(!that.keyword.trim()) {
                return;
            }

            const response = await HTTP.get('/srilanka/search-collection-codes/', {
                params: {
                    keyword: that.keyword
                }
            });

            if(response.data.length) {
                that.selectedCollectionCode = response.data[0];
            }

            if(!that.selectedCollectionCode) {
                that.$notify({
                    text: "No entries found.",
                    duration: 10000,
                    type: "warn"
                });

                return;
            }

            that.collectionCodeStatus = that.selectedCollectionCode.status;
            that.collectionCode = that.selectedCollectionCode.collection_code;
        },
        updateCollectionCodeStatus: function (status) {
            const that = this;
            HTTP.post("/srilanka/update-collection-code-status/", {
                status: status,
                collection_code: that.selectedCollectionCode.collection_code,
            })
                .then(() => {
                    that.selectedCollectionCode.status = status;
                    that.collectionCodeStatus = status;
                })
                .catch((error) => {
                    if ("message" in error.response.data) {
                        this.$notify({
                            text: error.response.data.message,
                            duration: 10000,
                            type: "error",
                        });
                    }
                });
        },
        filter: function () {
            const that = this;

            that.endDate = '';
            that.keyword = '';
            that.collectionCode = '';
            that.collectionCodeStatus = '';
            that.selectedCollectionCode = null;
        },
        download: function (code=null) {
            // let that = this;
            let filename = ''
            let params = {}

            if (code != null) {
                params.collection_code = code;
                filename = 'MosquitoDataDownload-' + code + '.csv';
            } else {
                filename = 'MosquitoDataDownload.csv';
            }

            HTTP.get('/srilanka/download-mosquito-data', {
                params: params
            }).then(response => {
                var fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                var fileLink = document.createElement("a");
                fileLink.href = fileURL;
                // const today = new Date();
                // fileLink.setAttribute("download", "MosquitoDataDownload-" + today + ".csv");
                fileLink.setAttribute("download", filename);
                document.body.appendChild(fileLink);
                fileLink.click();
            });
        },
        unpackUrlQueryParams(query_obj){
            if ("collectionCode" in query_obj) {
                this.collectionCode, this.keyword = query_obj.collectionCode;
                this.search();
            }
        },
    },
    beforeRouteUpdate(to, from, next) {
        // Since we are re-using the view, when it is updated, set the current tab to the 'to' route tabIndex or set it to
        // zero.
        this.tabIndex = to.query.tabIndex ? parseInt(to.query.tabIndex) : 0;
        next();
    },
};
</script>

<style>
@import "~handsontable/dist/handsontable.full.css";

.ht {
    width: 100%;
}
.nav-tabs .nav-link {
    font-weight: 500;
    color: #999;
}
</style>
